var map = {
	"./AcademicCap.svg": "9fff",
	"./AssessmentOfKnowledge.svg": "6343",
	"./Book.svg": "ac58",
	"./Help.svg": "38c7",
	"./Home.svg": "ba21",
	"./List.svg": "735b",
	"./Logout.svg": "2d40",
	"./MediaStorage.svg": "4836",
	"./OpenBook.svg": "386a",
	"./Patients.svg": "cdd5",
	"./Profile.svg": "94db",
	"./Task.svg": "76b4",
	"./menumenu-logo.svg": "a0f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a81";